export const PST_TIME_ZONE = "America/Los_Angeles";


export const dateOnlyToUTC = (dateStr) => {
  if (!dateStr) return null;

  if (dateStr.includes("T")) {
    return dateStr
  }

  const [year, month, day] = dateStr.split("-").map(Number);

  // Create a fake local date (no timezone shift)
  const localDate = new Date(year, month - 1, day);

  // Find PST offset (handles DST automatically)
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: PST_TIME_ZONE,
    hour: "numeric",
    hour12: false,
  }).formatToParts(localDate);

  const pstHour = Number(parts.find(p => p.type === "hour")?.value);

  // Convert PST midnight → UTC
  const utcHour = 24 - pstHour;

  return new Date(Date.UTC(year, month - 1, day, utcHour, 0, 0));
};

export const getFormattedDate = (value) => {
  
  if (!value) return "";

  let date;


  if (value instanceof Date) {
    date = value;
  }

  else if (typeof value === "string") {

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split("-").map(Number);
    return `${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}-${String(y).slice(-2)}`;
  }
    date = new Date(value);

    if (isNaN(date.getTime())) return "";
  }
  else {
    return "";
  }

  // 3️⃣ Format Date in PST
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: PST_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);

  const year = parts.find(p => p.type === "year")?.value;
  const month = parts.find(p => p.type === "month")?.value;
  const day = parts.find(p => p.type === "day")?.value;

  const shortYear = year ? year.slice(-2) : "";

  return `${month}-${day}-${shortYear}`;
};

export const getFullFormattedDate = (value) => {
  
  if (!value) return "";

  let date;


  if (value instanceof Date) {
    date = value;
  }

  else if (typeof value === "string") {

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split("-").map(Number);
    return `${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}-${y}`;
  }
    date = new Date(value);

    if (isNaN(date.getTime())) return "";
  }
  else {
    return "";
  }

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: PST_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);

  const year = parts.find(p => p.type === "year")?.value;
  const month = parts.find(p => p.type === "month")?.value;
  const day = parts.find(p => p.type === "day")?.value;

  return `${month}-${day}-${year}`;
};

export const getFormattedDateWithslash = (value) => {
  if (!value) return "";

  let date;

  if (value instanceof Date) {
    date = value;
  }
  else if (typeof value === "string") {
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [y, m, d] = value.split("-").map(Number);
      if (!y || !m || !d) return "";
      return `${String(m).padStart(2, "0")}/${String(d).padStart(2, "0")}/${(y)}`;
    }

    date = new Date(value);
    if (isNaN(date.getTime())) return "";
  } else {
    return "";
  }

  // Format Date in PST
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: PST_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);

  const year = parts.find(p => p.type === "year")?.value;
  const month = parts.find(p => p.type === "month")?.value;
  const day = parts.find(p => p.type === "day")?.value;

  if (!year || !month || !day) return "";

  return `${month}/${day}/${year}`;
};

// export const getDueDateMessage = (value) => {
//   if (!value) return "";

//   // Normalize the input to a local Date object
//   const dueDate = value instanceof Date ? value : backendDateToPickerDate(value);
//   if (!dueDate) return "";

//   // "Today" in PST — strip time to midnight for a clean day comparison
//   const nowPST = getTodayInPST();
//   const todayMidnight = new Date(nowPST.getFullYear(), nowPST.getMonth(), nowPST.getDate());

//   // Normalize dueDate to midnight too
//   const dueMidnight = new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate());

//   if (dueMidnight.getTime() === todayMidnight.getTime()) {
//     return "Due Today";
//   }

//   if (dueMidnight.getTime() < todayMidnight.getTime()) {
//     return "Overdue";
//   }

//   // Due date is in the future — return the display-formatted date
//   return getFormattedDate(dueDate);
// };

export const getDueDateMessage = (value) => {
  if (!value) return "";

  // Compare as "YYYY-MM-DD" strings for correct lexicographic ordering
  const todayStr = pickerDateToBackendDate(getTodayInPST()); // "YYYY-MM-DD"
  const dueDateStr = typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? value
    : pickerDateToBackendDate(backendDateToPickerDate(value)); // normalize to "YYYY-MM-DD"

  if (!dueDateStr) return "";

  if (dueDateStr === todayStr) return "Due Today";
  if (dueDateStr < todayStr) return "Overdue";

  return getFormattedDate(value); // return display format "MM-DD-YYYY" for future dates
};


export const getFormattedDateInDateRange =(dateStr) => { // in "YYYY-MM-DD"

  if (!dateStr || typeof dateStr !== 'string') return '';

  const [year, month, day] = dateStr.split('-').map(Number);

  const date = new Date(year, month - 1, day); // Month is 0-indexed

  const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
  const formattedDay = String(date.getDate()).padStart(2, '0');
  const formattedYear = date.getFullYear();

  return `${formattedMonth}-${formattedDay}-${formattedYear}`;
}

export const getFormattedDateByDate =(date) => { // in "YYYY-MM-DD"

 // If already in "YYYY-MM-DD" format (string), return as is
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }

  // If it's a Date object
  if (date instanceof Date && !isNaN(date)) {
    const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
    const formattedDay = String(date.getDate()).padStart(2, '0');
    const formattedYear = date.getFullYear();

    return `${formattedYear}-${formattedMonth}-${formattedDay}`;
  }
  return '';
}

export const parseDateField = (value) => {
  if (!value) return null;

  if (typeof value === "string") {
    const [year, month, day] = value.split("-").map(Number);
    if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
      return new Date(year, month - 1, day); 
    }
  }

  if (value instanceof Date) {
    return value;
  }

  return null;
}


export const getFormattedDateandTime = (dateStr) => {
  if (!dateStr) return '';

  const date = new Date(dateStr);

  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const year = date.getUTCFullYear();
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');

  return `${month}-${day}-${year} ${hours}:${minutes}`;
};

export const getFormattedDateandTime12hr = (dateStr) => {
  if (!dateStr) return '';

  const date = new Date(dateStr);

  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const year = date.getUTCFullYear();
  const utcHours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');

  const period = utcHours >= 12 ? 'PM' : 'AM';
  const hours12 = utcHours % 12 || 12; // Convert to 12-hour format (0 becomes 12)
  const hoursFormatted = String(hours12).padStart(2, '0');

  return `${month}-${day}-${year}   ${hoursFormatted}:${minutes} ${period}`;
};




export const getFormattedTime = (dateStr) => {
    if (!dateStr) return ''
    const date = new Date(dateStr)
    const hour = date.getHours().toString().padStart(2, "0")
    const minutes = date.getMinutes().toString().padStart(2,'0')
    return `${hour}:${minutes}`
  }

export function epochToPST(epoch) {
  const date = new Date(epoch);

  const options = {
    timeZone: PST_TIME_ZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric', // ✅ change here
    hour12: true,
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short'
  };

  return date.toLocaleString('en-US', options);
}
  

  export const getDueDate = (dateStr, paymentTerms = 0) => {
    try {
        const result = new Date(dateStr);
        if (isNaN(result.getTime())) {
            throw new Error('Invalid date string');
        }  
        result.setDate(result.getDate() + paymentTerms);
        return getFormattedDate(result.toString());
    } catch (error) {
        console.error('Error in getDueDate:', error);
        return null;
    }
};

export const calculateDueDatePassBy = (date) => {
    try {
        const currentDate = new Date();
        const inputDate = new Date(date);
        if (isNaN(inputDate.getTime())) {
            throw new Error('Invalid date');
        }  
        const timeDifference = currentDate - inputDate;
        const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24)); 
        return daysDifference > 0 ? daysDifference : '';
    } catch (error) {
        console.error('Error in calculateDueDatePassBy:', error);
        return null;
    }
};


export const getFormattedPhone = (phone) =>{
  if(!phone){
    return ""
  }
  let output = "(";
  phone.replace( /^\D*(\d{0,3})\D*(\d{0,3})\D*(\d{0,4})/, function( match, g1, g2, g3 )
      {
        if ( g1.length ) {
          output += g1;
          if ( g1.length == 3 ) {
              output += ")";
              if ( g2.length ) {
                  output += " " + g2; 
                  if ( g2.length == 3 ) {
                      output += " - ";
                      if ( g3.length ) {
                          output += g3;
                      }
                  }
              }
           }
        }
      }       
    );        
  return output;
}

export const capitalizeEachWord = (str) => {
    return str.split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  
export const convertToUpperCase = (str) =>{
    return str
      .toUpperCase()                 
      .replace(/[-_ ]/g, '');     
  }


export const getPayloadDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`; // Backend format (YYYY-MM-DD)
};




// backend string → DatePicker Date
// "2026-01-11" -> Date (local, fake date-only)
export const isoToBackendDate = (isoStr) => {
  if (!isoStr) return "";
  return isoStr.split("T")[0]; // "2026-01-04"
};

// YYYY-MM-DD → Date for picker
export const backendDateToPickerDate = (dateStr) => {
  if (!dateStr) return null;
  const [y, m, d] = isoToBackendDate(dateStr).split("-").map(Number);
  return new Date(y, m - 1, d);
};

// Date -> "2026-01-11"
export const pickerDateToBackendDate = (date) => {
  if (!date) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};


// Returns a Date that represents "today" in PST, at 23:59:59 PST
export const getTodayInPST = () => {
  // 1. Now, as a UTC-based Date
  const now = new Date();

  // 2. Format "today" in PST as y/m/d using Intl
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: PST_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);

  const year = Number(parts.find(p => p.type === "year").value);
  const month = Number(parts.find(p => p.type === "month").value);
  const day = Number(parts.find(p => p.type === "day").value);

  return new Date(year, month - 1, day, 23, 59, 59);
};


// ISO / timestamp → "YYYY-MM-DD" in PST
export const backendTimestampToPSTDateString = (value) => {
  if (!value) return "";

  const date = new Date(value);
  if (isNaN(date.getTime())) return "";

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);

  const year = parts.find(p => p.type === "year")?.value;
  const month = parts.find(p => p.type === "month")?.value;
  const day = parts.find(p => p.type === "day")?.value;

  return `${year}-${month}-${day}`;
};

export const getPSTFileDateTime = () => {
  const now = new Date();

  const pstDate = new Date(
    now.toLocaleString("en-US", {
      timeZone: PST_TIME_ZONE,
    })
  );

  const dd = String(pstDate.getDate()).padStart(2, "0");
  const mm = String(pstDate.getMonth() + 1).padStart(2, "0");
  const yy = String(pstDate.getFullYear()).slice(-2);

  const hh = String(pstDate.getHours()).padStart(2, "0");
  const min = String(pstDate.getMinutes()).padStart(2, "0");
  const ss = String(pstDate.getSeconds()).padStart(2, "0");

  return {
    date: `${dd}-${mm}-${yy}`,
    time: `${hh}_${min}_${ss}`,
  };
};

export const getDueDateMessageByDays = (value) => {
  if (!value) return "";

  const today = new Date(getTodayInPST());

  const date = new Date(
    typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)
      ? value
      : pickerDateToBackendDate(backendDateToPickerDate(value))
  );

  if (Number.isNaN(date.getTime())) return "";

  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);

  const diffDays = Math.round(
    (date.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)
  );

  if (diffDays === 0) return "Due Today";

  if (diffDays < 0) {
    const days = Math.abs(diffDays);
    return `${days}d Overdue`;
  }

  return `Due in ${diffDays}d`;
};